import { css } from '@emotion/react'
import { typo } from '@mathflat/common/style'

const S = {
  input: css`
    display: none;

    &:checked + label {
      border: solid 1px var(--Colors-Green-200);
      background-color: var(--Colors-Green-50);
      color: var(--Colors-Green-500);

      &.rounded {
        border: 1px solid var(--Colors-Green-200);
        background-color: var(--Colors-Green-50);
        color: var(--Colors-Green-500);
      }

      .choice-chip-icon > path {
        fill: var(--Colors-Green-500);
      }
    }

    &:disabled + label {
      border: 1px solid var(--Colors-Gray-200);
      color: var(--Colors-Gray-600);
      background-color: white;
      cursor: not-allowed;

      .choice-chip-icon > path {
        fill: var(--Colors-Gray-400);
      }
    }
  `,
  label: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 9px 12px;
    border: 1px solid var(--Colors-Gray-400);
    border-radius: var(--Radius-100);
    color: var(--Colors-Gray-700);
    background-color: white;
    white-space: pre;
    cursor: pointer;

    &.rounded {
      padding: 7px 14px;
      border-radius: var(--Radius-Circle);
    }

    &:hover {
      background-color: var(--Colors-Gray-100);
    }

    .choice-chip-icon {
      margin-right: 6px;
    }

    &.disabled-like,
    &.disabled-like:hover {
      border-color: var(--Colors-Gray-200);
      background-color: white;
      color: var(--Colors-Gray-600);
    }

    &.disabled-like:hover {
      cursor: default;
    }
  `,

  kmmInput: css`
    display: none;

    &:checked + label {
      background-color: var(--Colors-Green-50);
      color: var(--Colors-Green-500);
    }

    &:disabled + label {
      color: var(--Colors-Gray-400);
      background-color: var(--Colors-Gray-100);
      cursor: not-allowed;
    }
  `,

  kmmLabel: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 16px;
    color: var(--Colors-Gray-600);
    background-color: var(--Colors-Gray-100);
    margin-right: 8px;
    cursor: pointer;
    ${typo.body01};

    &.rounded {
      border-radius: var(--Radius-Circle);
    }

    &:hover {
      background-color: var(--Colors-Gray-300);
    }
  `,

  newInput: css`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;

    @media (hover: hover) {
      &:hover + label {
        background-color: var(--Colors-Gray-200);

        &.new-theme-sm {
          border-color: var(--Colors-Gray-400);
          background-color: var(--Colors-Gray-200);
        }
      }
    }

    &:focus-visible + label {
      // 적용 여부 확인 필요
    }

    &:active + label {
      background-color: #ebebeb;

      &.new-theme-sm {
        border-color: var(--Colors-Gray-200);
        background-color: var(--Colors-Gray-200);
      }
    }

    &:disabled + label {
      color: var(--Colors-Gray-600) !important;
      border-color: var(--Colors-Gray-200) !important;
      background-color: var(--Colors-White) !important;
      cursor: not-allowed;

      &.new-theme-sm {
        color: var(--Colors-Gray-400) !important;
        border-color: var(--Colors-Gray-200) !important;
        background-color: var(--Colors-White) !important;
      }
    }

    &:checked + label {
      color: var(--Colors-Green-500);
      border-color: var(--Colors-Green-200);
      background-color: var(--Colors-Green-50);

      &.new-theme-sm {
        color: var(--Colors-Green-500);
        border-color: var(--Colors-Green-300);
        background-color: var(--Colors-Green-50);
      }
    }

    @media (hover: hover) {
      &:checked:hover + label {
        background-color: #d6f0ff;

        &.new-theme-sm {
          color: var(--Colors-Green-500);
          border-color: var(--Colors-Green-300);
          background-color: var(--Colors-Green-100);
        }
      }
    }

    &:checked:active + label {
      background-color: #c2e8ff;

      &.new-theme-sm {
        color: var(--Colors-Green-500);
        border-color: var(--Colors-Green-300);
        background-color: var(--Colors-Green-100);
      }
    }

    &:checked:disabled + label {
      color: var(--Colors-Green-500) !important;
      background-color: var(--Colors-Green-50) !important;
      opacity: 0.5;

      &.new-theme-sm {
        color: var(--Colors-Green-200) !important;
        border-color: var(--Colors-Green-100) !important;
        background-color: var(--Colors-Green-50) !important;
        opacity: unset;
      }
    }
  `,
  newLabel: css`
    display: flex;
    align-items: center;
    gap: 2px;
    border-radius: var(--Radius-100);
    color: var(--Colors-Gray-900);
    border: 1px solid var(--Colors-Gray-400);
    background-color: white;
    ${typo.body02};
    cursor: pointer;
    white-space: nowrap;

    &.rounded {
      border-radius: var(--Radius-Circle);
    }

    &.new-theme-sm {
      height: 33px;
      padding: 0 8px;
      color: var(--Colors-Gray-900);
      border-color: var(--Colors-Gray-400);
    }

    &.new-theme-md {
      height: 35px;
      padding: 0 12px;
    }

    &.disabled-like,
    &.disabled-like:hover {
      border-color: var(--Colors-Gray-200);
      background-color: white;
      color: var(--Colors-Gray-600);
    }

    &.disabled-like:hover {
      cursor: default;
    }
  `,
}

export default S
